export const groupSeatingData = () => {
  return [
    {
      title: "all general group seating areas",
      color: "",
      earlyBird: "",
      regular: "",
      class: "allAreas",
      map: require("@/assets/images/GroupMaps/full-map.svg"),
      active: true,
    },
    {
      title: "select infield mezzanine",
      color: "#6F1619",
      // earlyBird: "39",
      regularOnlyStart: "67",
      class: "selectInfieldMezzanine",
      map: require("@/assets/images/GroupMaps/select-infield-mezzanine.svg"),
      description: "",
      sections: "SECTIONS <span>107-121</span><br>ROWS <span>2-10</span>",
      // capacity: "16-156",
      price:
        "price per ticket starting at <span>$67</span>*<br>ticket with loaded value starting at <span>$82</span>*",
      // "price per ticket starting at <span>$74</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "infield mezzanine",
      color: "#C10230",
      // earlyBird: "39",
      regularOnlyStart: "59",
      class: "infieldMezzanine",
      map: require("@/assets/images/GroupMaps/infield-mezzanine.svg"),
      description: "",
      sections: "SECTIONS <span>107-121</span><br>ROWS <span>11-20</span>",
      // capacity: "16-156",
      price:
        "price per ticket starting at <span>$59</span>*<br>ticket with loaded value starting at <span>$74</span>*",
      // "price per ticket starting at <span>$66</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "all you can eat",
      color: "#B3323B",
      // earlyBird: "32",
      regularOnlyStart: "50",
      class: "allYouCanEat",
      map: require("@/assets/images/GroupMaps/all-you-can-eat.svg"),
      description:
        "This Rangers fan-favorite space offers a spectacular view from lower left field, along with a ticket that includes all-you-can eat items like grilled chicken sandwiches, hamburgers, hot dogs, nachos, peanuts, popcorn, and unlimited soft drinks.",
      // heading: "new location for 2022!",
      sections: "SECTIONS <span>27-33</span>",
      capacity: "",
      price:
        "price per ticket starting at <span>$50</span>*<br>ticket with loaded value starting at <span>$65</span>*",
      // price: "price per 4 tickets <span>$000.00</span>.",
      // legal: "(Sold in increments of 4 seats)",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "corner box",
      color: "#E7E7E8",
      // earlyBird: "28",
      regularOnlyStart: "40",
      class: "cornerBox",
      map: require("@/assets/images/GroupMaps/empty-map.svg"),
      description: "",
      sections: "SECTIONS <span>1-4, 22-25</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$40</span>*<br>ticket with loaded value starting at <span>$55</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "mezzanine",
      color: "#E79C71",
      // earlyBird: "24",
      regularOnlyStart: "38",
      class: "mezzanine",
      map: require("@/assets/images/GroupMaps/mezzanine.svg"),
      description: "",
      sections: "SECTIONS <span>104-106, 122-124</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$38</span>*<br>ticket with loaded value starting at <span>$53</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "infield pavilion",
      color: "#BC9B72",
      // earlyBird: "22",
      regularOnlyStart: "36",
      // soldOut: true,
      class: "infieldPavilion",
      map: require("@/assets/images/GroupMaps/infield-pavillion.svg"),
      description: "",
      sections: "SECTIONS <span>214-220</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$36</span>*<br>ticket with loaded value starting at <span>$51</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "corner mezzanine",
      color: "#FFDD00",
      // earlyBird: "24",
      regularOnlyStart: "30",
      class: "mezzanine",
      map: require("@/assets/images/GroupMaps/corner-mezzanine.svg"),
      description: "",
      sections: "SECTIONS <span>101-103, 125-127</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$30</span>*<br>ticket with loaded value starting at <span>$45</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "sky box",
      color: "#96BE63",
      // earlyBird: "17",
      regularOnlyStart: "28",
      class: "skyBox",
      map: require("@/assets/images/GroupMaps/skybox-picnic.svg"),
      description:
        // "This spacious area located in a more exclusive area behind the seats in left field, offers plenty of room for your group to mingle with convenient access to concessions. The perfect space to host a semi-private picnic (groups of 50-225) with a spectacular view of the game.",
        "",
      sections: "SECTIONS <span>SB1-SB4</span>",
      // capacity: "50-225+",
      price:
        "price per ticket starting at <span>$28</span>*<br>ticket with loaded value starting at <span>$43</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // legal: "(Sold in increments of 4 seats)",
      carousel: [require("@/assets/images/PartyAreas/sky-box/sky-box-01.jpeg")],
      active: false,
    },
    {
      title: "outfield mezzanine",
      color: "#DB6015",
      // earlyBird: "17",
      regularOnlyStart: "28",
      class: "outfieldMezzanine",
      map: require("@/assets/images/GroupMaps/outfield-mezzanine.svg"),
      description: "",
      sections: "SECTIONS <span>128-133, 136-142</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$28</span>*<br>ticket with loaded value starting at <span>$43</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "budweiser sky porch",
      color: "#A5629B",
      // earlyBird: "14",
      regularOnlyStart: "23",
      class: "skyPorch",
      map: require("@/assets/images/GroupMaps/rocking-chairs.svg"),
      // description:
      //   "The Karbach Brewing Sky Porch, located in the left field mezzanine of the Upper Concourse, is an open space to socialize, perfect for corporate outings, family reunions or birthday celebrations.",
      sections: "SECTIONS <span>201-204</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$23</span>*<br>ticket with loaded value starting at <span>$38</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "baseline pavilion",
      color: "#002D74",
      // earlyBird: "17",
      regularOnlyStart: "28",
      class: "baselinePavilion",
      map: require("@/assets/images/GroupMaps/baseline-pavilion.svg"),
      description: "",
      sections: "SECTIONS <span>208-213, 221-228</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$28</span>*<br>ticket with loaded value starting at <span>$43</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "corner pavilion",
      color: "#80803F",
      // earlyBird: "12",
      regularOnlyStart: "18",
      class: "cornerPavilion",
      map: require("@/assets/images/GroupMaps/corner-pavilion.svg"),
      description: "",
      sections: "SECTIONS <span>205-207, 229-232</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$18</span>*<br>ticket with loaded value starting at <span>$33</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
   
    
    {
      title: "upper box",
      color: "#FEAEBB",
      // earlyBird: "10",
      regularOnlyStart: "15",
      class: "upperBox",
      map: require("@/assets/images/GroupMaps/upper-box.svg"),
      description: "",
      sections: "SECTIONS <span>308-317</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$15</span>*<br>ticket with loaded value starting at <span>$30</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
     {
      title: "lower pavilion",
      color: "#CAC164",
      // earlyBird: "10",
      regularOnlyStart: "14",
      class: "lowerPavilion",
      map: require("@/assets/images/GroupMaps/lower-pavilion.svg"),
      description: "",
      sections: "SECTIONS <span>233-237</span><br>ROWS <span>1-11</span><br>SECTIONS <span>238-239</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$14</span>*<br>ticket with loaded value starting at <span>$29</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "upper reserved",
      color: "#4CEFD7",
      // earlyBird: "9",
      regularOnlyStart: "14",
      class: "upperReserved",
      map: require("@/assets/images/GroupMaps/upper-reserved.svg"),
      description: "",
      sections: "SECTIONS <span>301-307, 318-324</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$14</span>*<br>ticket with loaded value starting at <span>$29</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "left field deck",
      color: "#78A3D4",
      // earlyBird: "10",
      regularOnlyStart: "13",
      class: "leftFieldDeck",
      map: require("@/assets/images/GroupMaps/left-field-deck.svg"),
      description: "",
      sections: "SECTIONS <span>240-244</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$13</span>*<br>ticket with loaded value starting at <span>$28</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "upper pavilion",
      color: "#FBEF89",
      // earlyBird: "10",
      regularOnlyStart: "10",
      class: "upperPavilion",
      map: require("@/assets/images/GroupMaps/upper-pavilion.svg"),
      description: "",
      sections: "SECTIONS <span>233-237</span><br>ROWS <span>12-22</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$10</span>*<br>ticket with loaded value starting at <span>$25</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
  ];
};
